// import React, { useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';

// const questions = [
//   {
//     id: 1,
//     question: 'What is the capital of France?',
//     options: ['Paris', 'London', 'Berlin', 'Madrid'],
//     answer: 'Paris',
//   },
//   {
//     id: 2,
//     question: 'Which planet is known as the Red Planet?',
//     options: ['Earth', 'Mars', 'Jupiter', 'Saturn'],
//     answer: 'Mars',
//   },
//   {
//     id: 3,
//     question: 'Who wrote "Hamlet"?',
//     options: ['Shakespeare', 'Tolstoy', 'Homer', 'Dante'],
//     answer: 'Shakespeare',
//   },
//   {
//     id: 4,
//     question: 'What is the largest ocean?',
//     options: ['Atlantic', 'Indian', 'Pacific', 'Arctic'],
//     answer: 'Pacific',
//   },
//   {
//     id: 5,
//     question: 'What is 2 + 2?',
//     options: ['3', '4', '5', '6'],
//     answer: '4',
//   },
// ];

// const Exam = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { mockData } = location.state || {};
//   const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
//   const [userAnswers, setUserAnswers] = useState([]);

//   const handleAnswerSelect = (option) => {
//     const updatedAnswers = [...userAnswers];
//     updatedAnswers[currentQuestionIndex] = { 
//       questionId: questions[currentQuestionIndex].id, 
//       answer: option 
//     };
//     setUserAnswers(updatedAnswers);
//   };

//   const handleNext = () => {
//     if (currentQuestionIndex < questions.length - 1) {
//       setCurrentQuestionIndex(currentQuestionIndex + 1);
//     } else {
//       // Navigate to results or submit the answers
//       console.log('Exam finished:', userAnswers);
//       navigate('/results', { state: { userAnswers, mockData } });
//     }
//   };

//   const currentQuestion = questions[currentQuestionIndex];

//   return (
//     <div className="p-8">
//       <h1 className="text-2xl font-bold mb-4">{mockData.text} - Exam</h1>
//       <p className="text-lg mb-4">{currentQuestion.question}</p>
//       {/* <div className="flex flex-col gap-2">
//         {currentQuestion.options.map((option) => (
//           <button
//             key={option}
//             onClick={() => handleAnswerSelect(option)}
//             className={`px-4 py-2 rounded-md border ${
//               userAnswers[currentQuestionIndex]?.answer === option
//                 ? 'bg-blue-500 text-white'
//                 : 'bg-white'
//             }`}
//           >
//             {option}
//           </button>
//         ))}
//       </div> */}
//        <div className="flex flex-col gap-4">
//         {currentQuestion.options.map((option) => (
//           <label
//             key={option}
//             className="flex items-center gap-2 cursor-pointer"
//           >
//             <input
//               type="radio"
//               name={`question-${currentQuestionIndex}`}
//               value={option}
//               checked={userAnswers[currentQuestionIndex]?.answer === option}
//               onChange={() => handleAnswerSelect(option)}
//               className="accent-blue-500"
//             />
//             <span>{option}</span>
//           </label>
//         ))}
//       </div>
//       <button
//         onClick={handleNext}
//         className="mt-4 px-4 py-2 bg-primary text-white rounded-md"
//       >
//         {currentQuestionIndex < questions.length - 1 ? 'Next' : 'Finish'}
//       </button>
//     </div>
//   );
// };

// export default Exam;
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';


const questions = [
  { id: 1, question: 'What is the capital of France?', options: ['Paris', 'London', 'Berlin', 'Madrid'], answer: 'Paris' },
  { id: 2, question: 'Which planet is known as the Red Planet?', options: ['Earth', 'Mars', 'Jupiter', 'Saturn'], answer: 'Mars' },
  { id: 3, question: 'Who wrote "Hamlet"?', options: ['Shakespeare', 'Tolstoy', 'Homer', 'Dante'], answer: 'Shakespeare' },
  { id: 4, question: 'What is the largest ocean?', options: ['Atlantic', 'Indian', 'Pacific', 'Arctic'], answer: 'Pacific' },
  { id: 5, question: 'What is 2 + 2?', options: ['3', '4', '5', '6'], answer: '4' },
];

const Exam = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { mockData } = location.state || {};
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [userAnswers, setUserAnswers] = useState([]);

  const handleAnswerSelect = (option) => {
    const updatedAnswers = [...userAnswers];
    updatedAnswers[currentQuestionIndex] = {
      questionId: questions[currentQuestionIndex].id,
      answer: option,
    };
    setUserAnswers(updatedAnswers);
  };

  const handleNext = () => {
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      navigate('/results', { state: { userAnswers, mockData } });
    }
  };

  const handlePrevious = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  const handleQuestionSelect = (index) => {
    setCurrentQuestionIndex(index);
  };

  const currentQuestion = questions[currentQuestionIndex];

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">{mockData?.text} - Exam</h1>
      <p className="text-lg mb-4">{currentQuestion.question}</p>
      <div className="flex flex-col gap-4">
        {currentQuestion.options.map((option) => (
          <label key={option} className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name={`question-${currentQuestionIndex}`}
              value={option}
              checked={userAnswers[currentQuestionIndex]?.answer === option}
              onChange={() => handleAnswerSelect(option)}
              className="accent-blue-500"
            />
            <span>{option}</span>
          </label>
        ))}
      </div>

      <div className="mt-4 flex gap-2">
        <button
          onClick={handlePrevious}
          className="px-4 py-2 bg-gray-300 text-black rounded-md disabled:opacity-50"
          disabled={currentQuestionIndex === 0}
        >
          Previous
        </button>
        <button
          onClick={handleNext}
          className="px-4 py-2 bg-primary text-white rounded-md"
        >
          {currentQuestionIndex < questions.length - 1 ? 'Next' : 'Finish'}
        </button>
      </div>

      {/* Question Navigator */}
      <div className="mt-4 flex gap-2 flex-wrap">
        {questions.map((_, index) => (
          <button
            key={index}
            onClick={() => handleQuestionSelect(index)}
            className={`w-10 h-10 rounded-full ${
              currentQuestionIndex === index
                ? 'bg-blue-500 text-white'
                : 'bg-gray-200 text-black'
            }`}
          >
            {index + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Exam;
